import { render, staticRenderFns } from "./ExhibitorFile.vue?vue&type=template&id=1a0d636c&"
import script from "./ExhibitorFile.vue?vue&type=script&lang=js&"
export * from "./ExhibitorFile.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitorFile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports